import axios from 'axios';
import URLS from '../../util/urls.js';

const state = {
  imoveisListados: [],
  imoveisParceriaListados: [],
  imovelPesquisa: {
    status: "DISPONIVEL",
    categoria: undefined,
    tipoImovel: undefined,
    operacao: "VENDA",
    filtroDashboard: undefined,
    valorInicial: undefined,
    valorFinal: undefined,
    area: undefined,
    quartos: undefined,
    suites: undefined,
    idNaImobiliaria: undefined,
    endereco: undefined,
    pagina: 0,
    condominio: {
      nome: ''
    }
  },
  imovelParceiroPesquisa: {
    status: 'DISPONIVEL',
    pagina: 0,
    dataCaptacaoInicio: '',
    dataCaptacaoFim: '',
    valorInicial: 0,
    operacao: 'VENDA',
    area: undefined,
    tipoImovel: undefined,
    endereco: '',
    suites: undefined,
    mobiliado: false,
    quartos: undefined,
    valorFinal: 0,
    condominio: {}
  },
  imovelSelecionado: {
    id: 0,
    categoria: 'IMOVEL_AVULSO',
    status: "DISPONIVEL",
    operacao: "VENDA",
    posseChave: 'PROPRIETARIO',
    autorizacaoPlaca: "PERMITIDO",
    valor: 0,
    tipoImovel: { id: 0 },
    pais: { id: 1 },
    estado: { id: 0 },
    cidade: { id: 0 },
    bairro: { id: 0 },
    cep: '',
    usuario: { id: 0 },
    condominio: { id: 0 },
    proprietario: { id: 0}, //atributo utilizado para validar o proprietario, não faz parte do objeto
    proprietariosBeneficiarios: [],
    caracteristicasImovel: [],
    caracteristicasCondominio: [],
    captadores: [],
    imagens: [],
    visitas: [],
    placas: [],
    observacoes: [],
    descricao: '',
    descricaoSite: ''
  },
  imovelParceiroSelecionado: {
    id: 0,
    categoria: 'IMOVEL_AVULSO',
    status: "DISPONIVEL",
    operacao: "ALUGUEL",
    posseChave: 'PROPRIETARIO',
    autorizacaoPlaca: "PERMITIDO",
    valor: 0,
    tipoImovel: { id: 0 },
    estado: { id: 0 },
    cidade: { id: 0 },
    bairro: { id: 0 },
    usuario: { id: 0 },
    condominio: { id: 0 },
    proprietario: { id: 0 }, //atributo utilizado para validar o proprietario, não faz parte do objeto
    proprietariosBeneficiarios: [],
    caracteristicasImovel: [],
    caracteristicasCondominio: [],
    captadores: [],
    imagens: [],
    visitas: [],
    placas: [],
    observacoes: [],
    descricao: '',
    descricaoSite: '',
    imobiliaria:{}
  },
  logs: [],
  formularios: [],

  clientesDisponiveis: [],
  cidadesDisponiveis: [],
  bairrosDisponiveis: [],
  condominiosDisponiveis: [],
  placasDisponiveis: [],

  labelQuantidade: '',
  exibirCamposPesquisa: false,

  ultimoIdCadastrado: undefined,

  visitaAtiva: {
    id: 0
  },
}

const mutations = {
  novoImovel(state) {
    state.imovelSelecionado = {
      id: 0,
      categoria: 'IMOVEL_AVULSO',
      status: "DISPONIVEL",
      operacao: "VENDA",
      posseChave: 'PROPRIETARIO',
      autorizacaoPlaca: "PERMITIDO",
      valor: 0,
      tipoImovel: { id: 0 },
      pais: { id: 1 },
      estado: { id: 0 },
      cidade: { id: 0 },
      bairro: { id: 0 },
      cep: '',
      usuario: { id : 0 },
      condominio: { id: 0 },
      proprietario: { id: 0},
      proprietariosBeneficiarios: [],
      caracteristicasImovel: [],
      caracteristicasCondominio: [],
      captadores: [],
      imagens: [],
      visitas: [],
      placas: [],
      observacoes: [],
      descricao: '',
      descricaoSite: ''
    };
    state.logs = [];

    state.clientesDisponiveis = [],
    state.cidadesDisponiveis = [];
    state.bairrosDisponiveis = [];
    state.condominiosDisponiveis = [];
    state.placasDisponiveis = [];
  },
  limparImovelPesquisa(state) {
    state.imovelPesquisa = {
      status: "DISPONIVEL",
      categoria: undefined,
      tipoImovel: undefined,
      operacao: "VENDA",
      filtroDashboard: undefined,
      valorInicial: undefined,
      valorFinal: undefined,
      area: undefined,
      quartos: undefined,
      suites: undefined,
      idNaImobiliaria: undefined,
      endereco: undefined,
      pagina: 0,
      condominio: {
        nome: ''
      }
    }
  },
  limparImovelParceiroPesquisa(state) {
    state.imovelParceiroPesquisa = {
      status: 'DISPONIVEL',
      pagina: 0,
      dataCaptacaoInicio: '',
      dataCaptacaoFim: '',
      valorInicial: 0,
      operacao: 'VENDA',
      area: undefined,
      tipoImovel: undefined,
      endereco: '',
      suites: undefined,
      mobiliado: false,
      quartos: undefined,
      valorFinal: 0,
      condominio: {}
    }
  },
  limparPlacasDisponiveis(state) {
    state.placasDisponiveis = [];
  },
  limparImoveisListados(state) {
    state.imoveisListados = [];
  },
  limparImoveisParceirosListas(state) {
    state.imoveisParceriaListados = []
  },
  configurarCamposPesquisa(state) {
    state.exibirCamposPesquisa = !state.exibirCamposPesquisa;
  },
  atualizarImovelPesquisa(state, payload) {
    state.imovelPesquisa = payload;
  },

  atualizarImoveisListados(state, payload) {
    if(state.imovelPesquisa.pagina == 0) {
      state.imoveisListados = payload.lista;
    } else {
      state.imoveisListados.push(...payload.lista);
    }
    state.labelQuantidade = payload.quantidade + (payload.quantidade == 1 ? " imóvel encontrado" : " imóveis encontrados")
  },
  atualizarImovelSelecionado(state, payload) {
    state.imovelSelecionado = payload;
    state.logs = [];

    if(payload.categoria === 'IMOVEL_AVULSO') {
      state.imovelSelecionado.proprietario = payload.proprietariosBeneficiarios[0];
      state.clientesDisponiveis = [payload.proprietariosBeneficiarios[0]];
    } else {
      state.imovelSelecionado.proprietario = { id: 0 }
      state.clientesDisponiveis = [state.imovelSelecionado.proprietario]
    }
    state.cidadesDisponiveis = [payload.cidade];
    state.bairrosDisponiveis = [payload.bairro];
    state.condominiosDisponiveis = [payload.condominio];
  },
  atualizarImovelParceiroSelecionado(state, payload) {
    state.imovelParceiroSelecionado = payload
  },
  atualizarClienteImovelSelecionado(state, payload) {
    state.imovelSelecionado.proprietariosBeneficiarios[0] = payload;
    state.imovelSelecionado.proprietario = state.imovelSelecionado.proprietariosBeneficiarios[0]
    state.clientesDisponiveis = [payload];
  },
  duplicarImovel(state, payload) {
    state.imovelSelecionado = {...payload.imovel,
      id: 0,
      idNaImobiliaria : "",
      status: "DISPONIVEL",
      operacao: "VENDA",
      imagens: [],
      visitas: [],
      placas:  [],
      observacoes: [],
    }
    
    state.logs = [];
    
    if(!payload.informacoesProprietario || payload.isLancamento) {
      state.imovelSelecionado.proprietariosBeneficiarios = [];
      state.clientesDisponiveis = [];
      state.imovelSelecionado.proprietario = { id: 0 };
    }

    if(!payload.caracteristicasImovel) {
      state.imovelSelecionado.caracteristicasImovel =  [];
    }

    if(!payload.caracteristicasCondominio) {
      state.imovelSelecionado.caracteristicasCondominio =  [];
    }
    
    if(!payload.captadores) {
      state.imovelSelecionado.captadores = [];
    }

    if(!payload.informacoesAdicionais) {
      state.imovelSelecionado.torres = undefined;
      state.imovelSelecionado.pavimentos = undefined;
      state.imovelSelecionado.elevadores = undefined;
      state.imovelSelecionado.unidadesPorAndar = undefined;

      state.imovelSelecionado.quartos = undefined;
      state.imovelSelecionado.banheiros = undefined;
      state.imovelSelecionado.suites = undefined;
      state.imovelSelecionado.suitesReversiveis = undefined;

      state.imovelSelecionado.garagensCobertas = undefined;
      state.imovelSelecionado.garagensNaoCobertas = undefined;

      state.imovelSelecionado.area = undefined;
      state.imovelSelecionado.dimensoesDoTerreno = undefined;
      state.imovelSelecionado.valorIPTU = undefined;
      state.imovelSelecionado.valorCondominio = undefined;
    }

    if(!payload.outrasInformacoes) {
      state.imovelSelecionado.posseChave = "PROPRIETARIO";
      state.imovelSelecionado.informacoesChave = undefined;
      state.imovelSelecionado.autorizacaoPlaca = "PERMITIDO";
      state.imovelSelecionado.descricao = undefined;
      state.imovelSelecionado.outrasInformacoes = undefined;
      state.imovelSelecionado.estadoConservacao = undefined;
      state.imovelSelecionado.anoConstrucao = undefined;
      state.imovelSelecionado.cartorioDeRegistro = undefined;
      state.imovelSelecionado.matriculaCartorio = undefined;
      state.imovelSelecionado.ocupado = false;
      state.imovelSelecionado.quitado = false;
      state.imovelSelecionado.financiado = false;
      state.imovelSelecionado.financiavel = false;

      state.imovelSelecionado.urlVideo = undefined;
    }

  },
  atualizarLogs(state, payload) {
    state.logs = payload;
  },

  atualizarClientesDisponiveis(state, payload) {
    state.clientesDisponiveis = payload;
  },
  atualizarCondominiosDisponiveis(state, payload) {
    state.condominiosDisponiveis = payload;
  },
  atualizarCidadesDisponiveis(state, payload) {
    state.cidadesDisponiveis = payload;
  },
  atualizarBairrosDisponiveis(state, payload) {
    state.bairrosDisponiveis = payload;
  },
  atualizarPlacasDisponiveis(state, payload) {
    state.placasDisponiveis = payload;
  },
  atualizarFormularios(state, payload) {
    state.formularios = payload;
  },
  atualizarArquivos(state, payload) {
    state.imovelSelecionado.diretorios = payload;
  },
  atualizarUltimoIdCadastrado(state, payload){
    state.ultimoIdCadastrado = payload.idNaImobiliaria;
  },
  atualizarVisitaAtiva(state, imovel) {
    imovel.visitas.forEach(element => {
      if (element.chavePosseCliente == true) {
        state.visitaAtiva = element;
      }
    })
  },
  limparVisitaAtiva(state) {
    state.visitaAtiva = {id: 0}
  },
  atualizarImoveisParceria(state, payload) {
    state.imoveisParceriaListados = payload
  },

  limparDadosEndereco(state) {
    state.imovelSelecionado.estado = { id: 0 }
    state.imovelSelecionado.cidade = { id: 0 }
    state.imovelSelecionado.bairro = { id: 0 }
    if(state.imovelSelecionado.cep) {
      state.imovelSelecionado.cep = ''
    }
  }
}

const actions = {
  novoImovel(context) {
    context.commit('novoImovel');
  },
  limparImovelPesquisa(context) {
    context.commit('limparImovelPesquisa');
  },
  limparImoveisListados(context) {
    context.commit('limparImoveisListados');
  },
  configurarCamposPesquisa(context) {
    context.commit('configurarCamposPesquisa');
  },
  atualizarImovelPesquisa(context, payload) {
    context.commit('atualizarImovelPesquisa', payload);
  },
  atualizarCondominiosDisponiveis(context, payload) {
    context.commit('atualizarCondominiosDisponiveis', payload);
  },
  atualizarCidadesDisponiveis(context, payload) {
    context.commit('atualizarCidadesDisponiveis', payload);
  },
  atualizarBairrosDisponiveis(context, payload) {
    context.commit('atualizarBairrosDisponiveis', payload);
  },
  limparImoveisParceirosListas(context) {
    context.commit('limparImoveisParceirosListas');
  },
  limparImovelParceiroPesquisa(context) {
    context.commit('limparImovelParceiroPesquisa')
  },
  limparDadosEndereco(context) {
    context.commit('limparDadosEndereco');
  },
  

  listarImoveis(context, payload) {
    return axios.post(URLS.IMOVEIS_LISTAR, payload)
    .then((response) => {
      switch(response.data.status) {
        case "SUCESSO":
          context.commit('atualizarImoveisListados', response.data);
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('listarImoveis', payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      context.commit('limparImoveisListados');
      throw error;
    });
  },
  recuperarImovel(context, payload) {
    return axios.post(URLS.IMOVEIS_RECUPERAR, payload)
    .then((response) => {
      switch(response.data.status) {
        case "SUCESSO":
          context.commit('limparVisitaAtiva');
          context.commit('atualizarImovelSelecionado', response.data.item);
          context.commit('atualizarVisitaAtiva', response.data.item);
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('recuperarImovel', payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      context.dispatch('novoImovel');
      throw error;
    });
  },
  gravarImovel(context, payload) {
    return axios.post(URLS.IMOVEIS_GRAVAR, payload)
    .then((response) => {
      switch(response.data.status) {
        case "SUCESSO":
          context.commit('atualizarImovelSelecionado', response.data.item);
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('gravarImovel', payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    })
  },
  gravarClienteNovoImovel(context, payload) {
    return axios.post(URLS.CLIENTES_GRAVAR, payload)
    .then((response) => {
      switch(response.data.status) {
        case "SUCESSO":
          context.commit('atualizarClienteImovelSelecionado', response.data.item);
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('gravarClienteNovoImovel', payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    });
  },
  removerImovel(context, payload) {
    return axios.post(URLS.IMOVEIS_REMOVER, payload)
    .then((response) => {
      switch(response.data.status) {
        case "SUCESSO":
          context.dispatch('novoImovel');
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('removerImovel', payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    });
  },

  disponibilizarImovel(context, payload) {
    return axios.post(URLS.IMOVEIS_DISPONIBILIZAR, payload)
    .then((response) => {
      switch(response.data.status) {
        case "SUCESSO":
          context.commit('atualizarImovelSelecionado', response.data.item);
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('disponibilizarImovel', payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    });
  },
  indisponibilizarImovel(context, payload) {
    return axios.post(URLS.IMOVEIS_INDISPONIBILIZAR, payload)
    .then((response) => {
      switch(response.data.status) {
        case "SUCESSO":
          context.commit('atualizarImovelSelecionado', response.data.item);
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('indisponibilizarImovel', payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    });
  },
  arquivarImovel(context, payload) {
    return axios.post(URLS.IMOVEIS_ARQUIVAR, payload)
    .then((response) => {
      switch(response.data.status) {
        case "SUCESSO":
          context.commit('atualizarImovelSelecionado', response.data.item);
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('arquivarImovel', payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    })
  },
  desarquivarImovel(context, payload) {
    return axios.post(URLS.IMOVEIS_DESARQUIVAR, payload)
    .then((response) => {
      switch(response.data.status) {
        case "SUCESSO":
          context.commit('atualizarImovelSelecionado', response.data.item);
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('desarquivarImovel', payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    })
  },

  duplicarImovel(context, payload) {
    context.commit('duplicarImovel', payload);
  },

  recuperarUltimoIdCadastrado(context, payload) {
    return axios.post(URLS.IMOVEIS_RECUPERAR_ULTIMO_ID, payload)
    .then((response) => {
      switch(response.data.status) {
        case "SUCESSO":
          context.commit('atualizarUltimoIdCadastrado', response.data.item);
          return;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('recuperarUltimoIdCadastrado', payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return;
      }
    }).catch((error) => {
      context.dispatch('novoImovel');
      throw error;
    });
  },

  gravarLocalizacaoImovel(context, payload) {
    return axios.post(URLS.IMOVEIS_GRAVAR_LOCALIZACAO, payload)
    .then((response) => {
      switch(response.data.status) {
        case "SUCESSO":
          context.commit('atualizarImovelSelecionado', response.data.item);
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then((authResponse) => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('gravarLocalizacaoImovel', payload);
            }
          }).catch((error) => {
            throw error;
          });
      }
    }).catch((error) => {
      throw error;
    });
  },

  //SELECTS
  recuperarClientes(context, payload) {
    return axios.post(URLS.CLIENTES_LISTAR, payload)
    .then((response) => {
      switch(response.data.status) {
        case "SUCESSO":
          context.commit('atualizarClientesDisponiveis', response.data.lista);
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('recuperarClientes', payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    });
  },
  recuperarCondominios(context, payload) {
    return axios.post(URLS.CONDOMINIOS_LISTAR, payload)
    .then((response) => {
      switch(response.data.status) {
        case "SUCESSO":
          context.commit('atualizarCondominiosDisponiveis', response.data.lista);
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('recuperarCondominios', payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    });
  },
  recuperarBairros(context, payload) {
    return axios.post(URLS.BAIRROS_LISTAR, payload)
    .then((response) => {
      switch(response.data.status) {
        case "SUCESSO":
          context.commit('atualizarBairrosDisponiveis', response.data.lista);
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch("loginStore/relogar", {}, { root: true })
          .then((authResponse) => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch("recuperarBairros", payload);
            }
          }).catch((error) => {
            throw error;
          });
      }
    }).catch((error) => {
      throw error;
    })
  },
  recuperarCidades(context, payload) {
    return axios.post(URLS.CIDADES_LISTAR, payload)
    .then((response) => {
      switch(response.data.status) {
        case "SUCESSO":
          context.commit('atualizarCidadesDisponiveis', response.data.lista);
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch("loginStore/relogar", {}, { root: true })
          .then((authResponse) => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch("recuperarCidades", payload);
            }
          }).catch((error) => {
            throw error;
          });
      }
    }).catch((error) => {
      throw error;
    })
  },

  //VISITAS
  recuperarVisita(context, payload) {
    return axios.post(URLS.IMOVEIS_RECUPERAR_VISITA_IMOVEL, payload)
    .then((response) => {
      switch(response.data.status) {
        case "SUCESSO":
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('recuperarVisita', payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    })
  },
  gravarVisitaImovel(context, payload) {
    return axios.post(URLS.IMOVEIS_GRAVAR_VISITA, payload)
    .then((response) => {
      switch(response.data.status) {
        case "SUCESSO":
          context.commit('atualizarImovelSelecionado', response.data.item);
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('gravarVisitaImovel', payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    });
  },
  gravarAvaliacaoVisita(context, payload){
    return axios.post(URLS.IMOVEIS_GRAVAR_AVALIACAO_VISITA, payload)
    .then((response) => {
      switch(response.data.status) {
        case "SUCESSO":
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('gravarAvaliacaoVisita', payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    })
  },
  removerVisitaImovel(context, payload) {
    return axios.post(URLS.IMOVEIS_REMOVER_VISITA, payload)
    .then((response) => {
      switch(response.data.status) {
        case "SUCESSO":
          context.commit('atualizarImovelSelecionado', response.data.item);
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('removerVisitaImovel', payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    })
  },
  gerarRelatorioVisita(context, payload) {
    return axios.post(URLS.RELATORIOS_GERAR, payload)
    .then((response) => {
      switch(response.data.status) {
        case "SUCESSO":
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('gerarRelatorioVisita', payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    });
  },
  
  // PLACAS
  recuperarPlacas(context, payload) {
    return axios.post(URLS.PLACAS_LISTAR, payload)
    .then((response) => {
      switch(response.data.status) {
        case "SUCESSO":
          context.commit('atualizarPlacasDisponiveis', response.data.lista);
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('recuperarPlacas', payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    })
  },
  gravarPlacaNoImovel(context, payload) {
    return axios.post(URLS.PLACAS_GRAVAR_PLACA_NO_IMOVEL, payload)
    .then((response) => {
      switch(response.data.status) {
        case "SUCESSO":
          context.commit('atualizarImovelSelecionado', response.data.item);
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('gravarPlacaNoImovel', payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    });
  },
  removerPlacaImovel(context, payload) {
    return axios.post(URLS.PLACAS_REMOVER_PLACA_DO_IMOVEL, payload)
    .then((response) => {
      switch(response.data.status) {
        case "SUCESSO":
          context.commit('atualizarImovelSelecionado', response.data.item);
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('removerPlacaImovel', payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    });
  },

  //OBSERVACOES
  recuperarObservacaoImovel(context, payload) {
    return axios.post(URLS.OBSERVACOES_RECUPERAR, payload)
    .then((response) => {
      switch(response.data.status) {
        case "SUCESSO":
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('recuperarObservacaoImovel', payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    });
  },
  gravarObservacaoImovel(context, payload) {
    return axios.post(URLS.OBSERVACOES_GRAVAR, payload)
    .then((response) => {
      switch(response.data.status) {
        case "SUCESSO":
          context.commit('atualizarImovelSelecionado', response.data.item);
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('gravarObservacaoImovel', payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    });
  },
  removerObservacaoImovel(context, payload) {
    return axios.post(URLS.OBSERVACOES_REMOVER, payload)
    .then((response) => {
      switch(response.data.status) {
        case "SUCESSO":
          context.commit('atualizarImovelSelecionado', response.data.item);
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('removerObservacaoImovel', payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    });
  },
  gerarRelatorioObservacoesImovel(context, payload) {
    return axios.post(URLS.RELATORIOS_GERAR, payload)
      .then((response) => {
        switch(response.data.status) {
          case "SUCESSO":
            return response.data;
          case "SESSAO_EXPIRADA":
            return context.dispatch('loginStore/relogar', {}, { root: true })
            .then(authResponse => {
              if(authResponse.status == "SUCESSO") {
                return context.dispatch('gerarRelatorioObservacoesImovel', payload);
              }
            }).catch((error) => {
              throw error;
            });
          default:
            return response.data;
        }
      }).catch((error) => {
        throw error;
      });
  },

  //FORMULÁRIOS
  recuperarFormularios(context, payload) {
    return axios.post(URLS.FORMULARIOS_RECUPERAR, payload)
    .then((response) => {
      switch(response.data.status) {
        case "SUCESSO":
          context.commit('atualizarFormularios', response.data.lista);
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('recuperarFormularios', payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    })
  },
  recuperarPerguntasFormulario(context, payload) {
    return axios.post(URLS.FORMULARIOS_RECUPERAR_PERGUNTAS, payload)
    .then((response) => {
      switch(response.data.status) {
        case "SUCESSO":
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('recuperarPerguntasFormulario', payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    })
  },
  gerarFormularioImovel(context, payload) {
    return axios.post(URLS.FORMULARIOS_GERAR, payload)
    .then((response) => {
      switch(response.data.status) {
        case "SUCESSO":
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('gerarFormularioImovel', payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    });
  },
  criarDiretorioImovel(context, payload) {
    return axios.post(URLS.FORMULARIOS_CRIAR_DIRETORIO, payload)
    .then(response => {
      switch(response.data.status) {
        case "SUCESSO":
          context.commit('atualizarFormularios', response.data.lista);
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('criarDiretorioImovel', payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    })
  },
  criarDiretorioArquivoImovelVenda(context, payload) {
    return axios.post(URLS.ARQUIVOS_CRIAR_DIRETORIO, payload)
    .then(response => {
      switch(response.data.status) {
        case "SUCESSO":
          context.commit('atualizarArquivos', response.data.lista);
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('criarDiretorioArquivoImovelVenda', payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    })
  },
  removerDiretorioFormularios(context, payload) {
    return axios.post(URLS.FORMULARIOS_REMOVER_DIRETORIO, payload)
    .then((response) => {
      switch(response.data.status) {
        case "SUCESSO":
          context.commit('atualizarFormularios', response.data.lista);
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('removerDiretorioFormularios', payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    })
  },
  removerDiretorioArquivos(context, payload) {
    return axios.post(URLS.ARQUIVOS_REMOVER_DIRETORIO, payload)
    .then((response) => {
      switch(response.data.status) {
        case "SUCESSO":
          context.commit('atualizarArquivos', response.data.lista);
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('removerDiretorioArquivos', payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    })
  },
  selecionarDiretorioImovelVenda(context, payload) {
    return axios.post(URLS.FORMULARIOS_SELECIONAR_DIRETORIO, payload)
    .then((response) => {
      switch(response.data.status) {
        case "SUCESSO":
          context.commit('atualizarFormularios', response.data.lista);
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('selecionarDiretorioImovelVenda', payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    });
  },

  selecionarDiretorioArquivoImovelVenda(context, payload) {
    return axios.post(URLS.ARQUIVOS_SELECIONAR_DIRETORIO, payload)
    .then((response) => {
      switch(response.data.status) {
        case "SUCESSO":
          context.commit('atualizarArquivos', response.data.lista);
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('selecionarDiretorioArquivoImovelVenda', payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    });
  },

  //ARQUIVOS
  uploadArquivoImovel(context, payload) {
    return axios.post(URLS.ARQUIVOS_UPLOAD, payload, { headers: { 'Content-Type': 'multipart/form-data' } })
    .then((response) => {
      switch(response.data.status) {
        case "SUCESSO":
          context.commit('atualizarImovelSelecionado', response.data.item);
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('uploadArquivoImovel', payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    })
  },
  removerArquivoImovel(context, payload) {
    return axios.post(URLS.ARQUIVOS_REMOVER, payload)
    .then((response) => {
      switch(response.data.status) {
        case "SUCESSO":
          context.commit('atualizarImovelSelecionado', response.data.item);
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('removerArquivoImovel', payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    })
  },

  //IMAGENS
  uploadImagemImovel(context, payload) {
    return axios.post(URLS.IMAGENS_UPLOAD, payload, { headers: { 'Content-Type': 'multipart/form-data' } })
    .then((response) => {
      switch(response.data.status) {
        case "SUCESSO":
          context.commit('atualizarImovelSelecionado', response.data.item);
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('uploadImagemImovel', payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    })
  },
  reordenarImagensImovel(context, payload) {
    return axios.post(URLS.IMAGENS_REORDENAR, payload)
    .then((response) => {
      switch(response.data.status) {
        case "SUCESSO":
          context.commit('atualizarImovelSelecionado', response.data.item);
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true})
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('reordenarImagensImovel', payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    });
  },
  removerImagensImovel(context, payload) {
    return axios.post(URLS.IMAGENS_REMOVER, payload)
    .then((response) => {
      switch(response.data.status) {
        case "SUCESSO":
          context.commit('atualizarImovelSelecionado', response.data.item);
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true})
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('removerImagensImovel', payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    });
  },
  exibirImagemNaFichaImovel(context, payload) {
    return axios.post(URLS.IMAGENS_EXIBIR_NA_FICHA, payload)
    .then((response) => {
      switch(response.data.status) {
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true})
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('exibirImagemNaFichaImovel', payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    });
  },
  
  //RESERVAS
  reservarImovel(context, payload) {
    return axios.post(URLS.IMOVEIS_RESERVAR_IMOVEL, payload)
    .then((response) => {
      switch(response.data.status) {
        case "SUCESSO":
          context.commit('atualizarImovelSelecionado', response.data.item);
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('reservarImovel', payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    })
  },
  prorrogarReservaImovel(context, payload) {
    return axios.post(URLS.IMOVEIS_PRORROGAR_RESERVA_IMOVEL, payload)
    .then((response) => {
      switch(response.data.status) {
        case "SUCESSO":
          context.commit('atualizarImovelSelecionado', response.data.item);
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('prorrogarReservaImovel', payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    })
  },
  desfazerReserva(context, payload) {
    return axios.post(URLS.IMOVEIS_DESFAZER_RESERVA, payload)
    .then((response) => {
      switch(response.data.status) {
        case "SUCESSO":
          context.commit('atualizarImovelSelecionado', response.data.item);
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('desfazerReserva', payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    });
  },

  entregarChave(context, payload) {
    return axios.post(URLS.IMOVEIS_ENTREGAR_CHAVE, payload)
      .then(response => {
        switch(response.data.status) {
          case 'SUCESSO':
            context.commit('limparVisitaAtiva');
            context.commit('atualizarImovelSelecionado', response.data.item);
            context.commit('atualizarVisitaAtiva', response.data.item);
            return response.data;
          case 'SESSAO_EXPIRADA':
            return context.dispatch('loginStore/relogar', {}, { root: true })
              .then(authResponse => {
                if(authResponse.status === 'SUCESSO') {
                  return context.dispatch('entregarChave', payload);
                }
              }).catch(error => { throw error });
          default:
            return response.data;
        }
      }).catch(error => { throw error });
  },
  receberChave(context, payload) {
    return axios.post(URLS.IMOVEIS_RECEBER_CHAVE, payload)
      .then(response => {
        switch(response.data.status) {
          case 'SUCESSO':
            context.commit('limparVisitaAtiva');
            context.commit('atualizarImovelSelecionado', response.data.item);
            context.commit('atualizarVisitaAtiva', response.data.item)
            return response.data;
          case 'SESSAO_EXPIRADA':
            return context.dispatch('loginStore/relogar', {}, { root: true })
              .then(authResponse => {
                if(authResponse.status === 'SUCESSO') {
                  return context.dispatch('receberChave', payload);
                }
              }).catch(error => { throw error });
          default:
            return response.data;
        }
      }).catch(error => { throw error });
  },

  //LOGS
  recuperarLogsImovel(context, payload) {
    return axios.post(URLS.LOGGER_LISTAR, payload)
    .then((response) => {
      switch(response.data.status) {
        case "SUCESSO":
          context.commit('atualizarLogs', response.data.lista);
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('recuperarLogsImovel', payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    });
  },

  //RELATORIOS
  gerarRelatoriosImovel(context, payload) {
    return axios.post(URLS.RELATORIOS_GERAR, payload)
    .then((response) => {
      switch(response.data.status) {
        case "SUCESSO":
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('gerarRelatoriosImovel', payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    });
  },
  enviarRelatoriosImovelPorEmail(context, payload) {
    return axios.post(URLS.RELATORIOS_ENVIAR_POR_EMAIL, payload)
      .then((response) => {
        switch(response.data.status) {
          case "SUCESSO":
            return response.data;
          case "SESSAO_EXPIRADA":
            return context.dispatch('loginStore/relogar', {}, { root: true })
            .then(authResponse => {
              if(authResponse.status == "SUCESSO") {
                return context.dispatch('enviarRelatoriosImovelPorEmail', payload);
              }
            }).catch((error) => {
              throw error;
            });
          default:
            return response.data;
        }
      }).catch((error) => {
        throw error;
      });
  },

  gerarDeclaracaoRetiradaChave(context, payload) {
    return axios.post(URLS.RELATORIOS_GERAR, payload)
      .then(response => {
        switch(response.data.status) {
          case 'SESSAO_EXPIRADA':
            return context.dispatch('loginStore/relogar', {}, { root: true })
              .then(authResponse => {
                if(authResponse.status === 'SUCESSO') {
                  return context.dispatch('gerarDeclaracaoRetiradaChave', payload);
                }
              })
              .catch(error => { throw error });
          default:
            return response.data;
        }
      })
      .catch(error => { throw error });
  },

  disponibilizarAluguelImovel(context, payload) {
    return axios.post(URLS.IMOVEIS_DISPONIBILIZAR_ALUGUEL, payload)
    .then((response) => {
      switch(response.data.status) {
        case "SUCESSO":
          context.commit('atualizarImovelSelecionado', response.data.item);
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('disponibilizarAluguelImovel', payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    });
  },

  listarImoveisParceiros(context, payload) {
    return axios.post(URLS.PARCERIAS_LISTAR_IMOVEIS_PARCEIROS, payload)
    .then((response) => {
      switch (response.data.status) {
        case 'SUCESSO':
          context.commit('atualizarImoveisParceria', response.data.lista)
          return response.data;
        case 'SESSAO_EXPIRADA':
          return context.dispatch('loginStores/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status === 'SUCESSO') {
              return context.dispatch('listarImoveisParceiros', payload);
            }
          }).catch(error => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch(error => {
      throw error;
    })
  },

  recuperarImovelParceiro(context, payload) {
    return axios.post(URLS.PARCERIAS_RECUPERAR_IMOVEL, payload)
    .then((response) => {
      switch (response.data.status) {
        case 'SUCESSO':
          return response.data;
        case 'SESSAO_EXPIRADA':
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status === 'SUCESSO') {
              return context.dispatch('recuperarImovelParceiro', payload);
            }
          }).catch(error => {
            throw error;
          });
        default:
          context.commit('atualizarImovelParceiroSelecionado', response.data);
          return response.data;
      }
    }).catch(error => {
      throw error;
    })
  }
}

export default {
  state,
  mutations,
  actions
}